import { render } from "./programSetup.vue?vue&type=template&id=1e42963e&scoped=true"
import script from "./programSetup.vue?vue&type=script&lang=js"
export * from "./programSetup.vue?vue&type=script&lang=js"

import "./programSetup.vue?vue&type=style&index=0&id=1e42963e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e42963e"]])

export default __exports__